import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StockReportView from "./StockReportView";
import SalesReportView from "./SalesReportView";
import GstSummaryView from "./GstSummaryView";
import HsnSummaryView from "./HsnSummaryView";
import Gstr3bView from "./Gstr3bView";
import Gstr1ExportView from "./Gstr1ExportView";


const TABS = [
  { key: "stock", label: "Stock Report", icon: "fa-solid fa-boxes-stacked" },
  { key: "sales", label: "Sales Report", icon: "fa-solid fa-chart-line" },
   { key: "gst", label: "GST Summary", icon: "fa-solid fa-file-invoice" }, // added later
    { key: "hsn", label: "HSN Summary", icon: "fa-solid fa-list-check" },
     { key: "gstr3b", label: "GSTR-3B", icon: "fa-solid fa-file-invoice-dollar" },
     { key: "gstr1", label: "GSTR-1 Export", icon: "fa-solid fa-file-export" },
];

const Reports = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("stock");

  return (
    <div>
      <div className="invoice-card-wrapper vt-card-wrapper">
        <div>
          <div className="card invoice-card">
            <div className="card-body p-0">

              {/* ══ HEADER ══ */}
              <div className="invoice-right-panel-header">
                <div className="vt-right-header-left">
                  <div onClick={() => navigate(-1)} style={{ cursor: "pointer", fontSize: "16px", color: "#333" }}>
                    <i className="fa-solid fa-arrow-left"></i>
                  </div>
                  <h6 className="invoice-right-panel-title">Reports</h6>
                </div>
                <div onClick={() => navigate(-1)} style={{ cursor: "pointer", fontSize: "18px", color: "#555" }}>
                  <i className="fa-solid fa-xmark"></i>
                </div>
              </div>

              {/* ══ TABS ══ */}
              <div style={{ display: "flex", gap: "8px", padding: "16px 20px 0 20px", borderBottom: "1px solid #eee" }}>
                {TABS.map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      padding: "10px 18px",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: activeTab === tab.key ? "700" : "500",
                      color: activeTab === tab.key ? "#1976d2" : "#666",
                      borderBottom: activeTab === tab.key ? "2px solid #1976d2" : "2px solid transparent",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i className={tab.icon}></i>
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* ══ BODY — active tab's content ══ */}
              <div style={{ padding: "20px" }}>
                {activeTab === "stock" && <StockReportView />}
                {activeTab === "sales" && <SalesReportView />}
                {activeTab === "gst" && <GstSummaryView />}
                {activeTab === "hsn" && <HsnSummaryView />}
                {activeTab === "gstr3b" && <Gstr3bView />}
                {activeTab === "gstr1" && <Gstr1ExportView />}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;